import { createRouter, createWebHashHistory } from 'vue-router';
import SharePage from './SharePage.vue';

export const shareRouter = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/:share_id',
            component: SharePage,
        }
    ],
})

export default shareRouter;
